var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJiajingban(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_31_2516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 683",
    d: "M3.04551 10.646L1.56608 12.3967C1.42089 12.5685 1.4083 12.8161 1.53532 13.0017L1.57764 13.0636C1.67084 13.1998 1.82525 13.2812 1.99029 13.2812H3.44501C3.58464 13.2812 3.71791 13.2229 3.81257 13.1202L5.4841 11.3077C5.77952 10.9874 5.55231 10.4688 5.11654 10.4688H3.4274C3.28022 10.4688 3.14051 10.5336 3.04551 10.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 682",
    d: "M3.63281 10.3438V12.8333C3.63281 13.1095 3.40895 13.3333 3.13281 13.3333H1.07031",
    stroke: "black",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 65",
    x1: 1.29515,
    y1: 12.8334,
    x2: 3.5139,
    y2: 10.3334,
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 66",
    x1: 3.81264,
    y1: 13.4178,
    x2: 6.23451,
    y2: 10.6313,
    stroke: "black",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 4791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 683_2",
    d: "M8.18613 10.646L6.70671 12.3967C6.56151 12.5685 6.54893 12.8161 6.67595 13.0017L6.71826 13.0636C6.81146 13.1998 6.96587 13.2812 7.13092 13.2812H8.58563C8.72526 13.2812 8.85853 13.2229 8.95319 13.1202L10.6247 11.3077C10.9201 10.9874 10.6929 10.4688 10.2572 10.4688H8.56803C8.42084 10.4688 8.28113 10.5336 8.18613 10.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 682_2",
    d: "M8.77344 10.3438V12.8333C8.77344 13.1095 8.54958 13.3333 8.27344 13.3333H6.21094",
    stroke: "black",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 65_2",
    x1: 6.43578,
    y1: 12.8334,
    x2: 8.65453,
    y2: 10.3334,
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 66_2",
    x1: 8.95326,
    y1: 13.4178,
    x2: 11.3751,
    y2: 10.6313,
    stroke: "black",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 570",
    d: "M1.28125 10.625V8.72024L6.11523 2.625H16.75V4.45357L11.916 10.625H1.28125Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.933333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631154",
    d: "M1.32801 8.41167L5.95073 2.49458H16.3049L11.5501 8.41167H1.32801Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.426667
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_2516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiajingban);
export default __webpack_public_path__ + "static/media/jiajingban.70b708c5c0d84cc3a942912b32279db9.svg";
export { ForwardRef as ReactComponent };